<template>
  <div>
    <search-agent-profile @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showRegisterEimModal"
          v-if="isShowMenu('agent_profiles/register_eim')"
        >注册eIM</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    >
      <span slot="actions" slot-scope="text, record">
        <a @click="updateEimData(record)" :disabled="updatingId === record.id">更新</a>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <register-profile-to-eim
      v-if="isShowRegisterEimModal"
      :visible.sync="isShowRegisterEimModal"
      :agent-id="agentId"
      :iccids="selectedIccids"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findAgentProfiles } from '@/api/agent'
import { updateProfileEimData } from '@/api/profile'
import Pagination from '@/components/Pagination'
import SearchAgentProfile from '@/views/profiles/agent/Search'
import { formatFloat } from '@/utils/filter'

export default {
  name: 'AgentProfileList',
  components: {
    Pagination,
    SearchAgentProfile,
    RegisterProfileToEim: () => import('@/views/batch_operations/RegisterProfileToEim')
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowRegisterEimModal: false,
      selectedRowKeys: [],
      updatingId: 0,
      pagination: { total_count: 0 },
      query: { per_page: 10 }
    }
  },
  computed: {
    agentId() {
      return parseInt(this.$route.params.id)
    },
    selectedIccids() {
      const idSet = new Set(this.selectedRowKeys)
      return this.data
        .filter((row) => idSet.has(row.id))
        .map((row) => row.iccid)
        .filter((iccid) => iccid)
    },
    columns() {
      return [
        { title: 'ICCID', dataIndex: 'iccid', width: 220, fixed: 'left' },
        { title: 'MSISDN', dataIndex: 'msisdn', width: 140 },
        { title: '激活码', dataIndex: 'activation_code', width: 220, ellipsis: true },
        { title: 'MatchingID', dataIndex: 'matching_id', width: 160, ellipsis: true },
        { title: 'SM-DP+地址', dataIndex: 'smdp_address', width: 160, ellipsis: true },
        { title: 'SM-DP+平台', dataIndex: 'smdp_platform_name', width: 120 },
        { title: 'SGP协议', dataIndex: 'sgp_spec_name', width: 100 },
        { title: 'ProfileType', dataIndex: 'profile_type', width: 180, ellipsis: true },
        { title: 'PRP规则', dataIndex: 'prp_id_text', width: 200 },
        { title: '状态', dataIndex: 'status_text', width: 120 },
        { title: '下载次数', dataIndex: 'download_counter', width: 100 },
        { title: '首次下载时间', dataIndex: 'first_download_date', width: 160 },
        { title: '设备', dataIndex: 'device', width: 140, ellipsis: true },
        { title: '关联 EID', dataIndex: 'eid', width: 220, ellipsis: true },
        { title: '产品名称', dataIndex: 'product_name', width: 160 },
        { title: 'eIM平台', dataIndex: 'eim_platform_name', width: 120 },
        { title: 'eIM注册状态', dataIndex: 'eim_register_status_name', width: 120 },
        { title: '状态（EIM）', dataIndex: 'eim_status_text', width: 120 },
        { title: '重复下载规则（EIM）', dataIndex: 'eim_prp_code_name', width: 180 },
        { title: '供应商', dataIndex: 'profile_supplier_name', width: 140 },
        {
          title: 'Profile费(元)',
          dataIndex: 'profile_fee',
          width: 120,
          customRender: (t) => formatFloat(t)
        },
        { title: '备注', dataIndex: 'remark', width: 160, ellipsis: true },
        { title: '订单编号', dataIndex: 'order_no', width: 180, ellipsis: true },
        { title: '划拨时间', dataIndex: 'allocated_at', width: 170 },
        { title: '操作', dataIndex: 'actions', scopedSlots: { customRender: 'actions' }, width: 80, fixed: 'right' }
      ]
    }
  },
  watch: {
    agentId() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showRegisterEimModal() {
      this.isShowRegisterEimModal = true
    },
    updateEimData(record) {
      if (!record || !record.id) return
      this.updatingId = record.id
      updateProfileEimData(record.id).then((res) => {
        this.updatingId = 0
        if (res.code === 0) {
          this.$message.success(res.message || '操作成功，请稍后刷新查看')
        }
      }).catch(() => {
        this.updatingId = 0
      })
    },
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findAgentProfiles(this.agentId, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    }
  }
}
</script>
